import { useCommunityMemeberStats } from "../../../../../hooks/manageMembers/useCommunityMemeberStats";
import { CommunityFormEnum } from "../../../../community/enums/CommunityFormEnum";

type Props = {
    userId: number;
    section: CommunityFormEnum;
    reloadKey?: number;
}

export const ProfileMemberCommunityStats = ({ userId, section, reloadKey }: Props) => {
    const { stats, loading } = useCommunityMemeberStats(userId, section, reloadKey);

    return (
        <>
        { stats && !loading &&
            <div className="d-flex flex-row w-100" style={{ gap: '15px' }}>
                <div className="stat-card">
                    <div className="stat-card__content">
                        <div className="stat-card__label">
                            Total Requests
                        </div>
                        <div className="stat-card__value">
                            {stats.totalRequests}
                        </div>
                    </div>
                </div>
                <div className="stat-card">
                    <div className="stat-card__content">
                        <div className="stat-card__label">
                            Declined
                        </div>
                        <div className="stat-card__value">
                            {stats.declined}
                        </div>
                    </div>
                </div>
                <div className="stat-card">
                    <div className="stat-card__content">
                        <div className="stat-card__label">
                            Accepted
                        </div>
                        <div className="stat-card__value">
                            {stats.accepted}
                        </div>
                    </div>
                </div>
                <div className="stat-card">
                    <div className="stat-card__content">
                        <div className="stat-card__label">
                            Unanswered
                        </div>
                        <div className="stat-card__value">
                            {stats.unanswered}
                        </div>
                    </div>
                </div>
                <div className="stat-card">
                    <div className="stat-card__content">
                        <div className="stat-card__label">
                            Banned
                        </div>
                        <div className="stat-card__value">
                            {stats.banned}
                        </div>
                    </div>
                </div>
            </div>
        }
        </>
    )
}